import script from "./AdminServices.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminServices.vue?vue&type=script&setup=true&lang=js"

import "./AdminServices.vue?vue&type=style&index=0&id=62c633d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62c633d5"]])

export default __exports__